<div id="container" class="bg-panel dark:bg-dark-panel h-[600px] flex flex-col">

  <div class="sticky top-0 z-10 bg-header dark:bg-dark-header border-b border-gray-200 dark:border-dark-background">
    <div class="flex flex-row justify-between items-start p-4">

      <div class="flex items-start gap-4 flex-1 min-w-0">

        <div class="flex flex-col text-center shadow rounded-md overflow-hidden flex-shrink-0"
          *ngIf="article || (calendarActivity && calendarActivity.date)">
          <span class="text-xs font-bold text-white bg-red-600 dark:bg-red-700 px-3 py-1">
            {{ (article?.date || calendarActivity?.date) | date: 'MMM' | uppercase }}
          </span>
          <span class="text-lg font-semibold text-gray-900 dark:text-white bg-white dark:bg-gray-700 px-3">
            {{ (article?.date || calendarActivity?.date) | date: 'dd' }}
          </span>
        </div>


        <div *ngIf="calendarActivity && !article && !calendarActivity.date" class="flex-shrink-0">
          <app-calendar-activity [activity]="calendarActivity" [types]="calendarActivityTypes" [showDate]="true"
            [truncAt]="200"></app-calendar-activity>
        </div>


        <div class="flex flex-col flex-1 min-w-0">
          <span
            class="text-xs font-semibold py-1 px-2 uppercase rounded text-blue-600 bg-blue-200 dark:text-blue-200 dark:bg-blue-600 {{replace(article?.doc_type || getActivityType() || '')}} mb-2 w-fit"
            *ngIf="article?.doc_type || getActivityType()">
            {{ article?.doc_type || getActivityType() }}
          </span>
          <div class="text-sm text-white truncate" [title]="getActivityTitle()">
            {{ getActivityTitle() }}
          </div>

          <div *ngIf="calendarActivity && !article" class="text-xs text-gray-200 mt-1">
            <span *ngIf="calendarActivity.chamber">{{ calendarActivity.chamber }}</span>
            <span *ngIf="calendarActivity.chamber && calendarActivity.detail?.number"> | </span>
            <span *ngIf="calendarActivity.detail?.number">#{{ calendarActivity.detail.number }}</span>
          </div>
        </div>
      </div>


      <button (click)="closeModal()" class="ml-4 flex-shrink-0">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-6 h-6 text-white hover:text-gray-300">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>


  <div class="p-4 bg-panel dark:bg-dark-panel">
    <div class="flex flex-row gap-3">

      <div class="relative flex-1">
        <div (click)="action = PinAction.ADD_NEW"
          [class]="action === PinAction.ADD_NEW ? 'border-blue-500 bg-blue-50 dark:bg-blue-900 dark:border-blue-400' : 'border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-dark-background'"
          class="flex p-4 bg-white dark:bg-dark-sidebar border-2 rounded-lg cursor-pointer transition-all duration-200 h-20">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-5 h-5 mr-3 text-gray-600 dark:text-gray-300 mt-0.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
          </svg>
          <div class="flex flex-col justify-center">
            <span class="text-base font-medium text-gray-900 dark:text-white">Create New Board</span>
            <p class="text-xs text-gray-500 dark:text-gray-400">Start a new board with this content</p>
          </div>
        </div>
      </div>


      <div class="relative flex-1">
        <div (click)="boards.length && (action = PinAction.ADD_TO_EXISTING)" [class]="[
               action === PinAction.ADD_TO_EXISTING && boards.length ? 'border-blue-500 bg-blue-50 dark:bg-blue-900 dark:border-blue-400' : 'border-gray-300 dark:border-gray-600',
               boards.length ? 'cursor-pointer hover:bg-gray-50 dark:hover:bg-dark-background' : 'cursor-not-allowed opacity-60 bg-gray-100 dark:bg-gray-800'
             ]" class="flex p-4 bg-white dark:bg-dark-sidebar border-2 rounded-lg transition-all duration-200 h-20">
          <div class="flex mr-3 mt-0.5">
            <div class="relative">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor"
                [class]="boards.length ? 'w-5 h-5 text-gray-600 dark:text-gray-300' : 'w-5 h-5 text-gray-400 dark:text-gray-500'">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 0 1-2.25 2.25M16.5 7.5V18a2.25 2.25 0 0 0 2.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 0 0 2.25 2.25h13.5M6 7.5h3v3H6v-3Z" />
              </svg>
              <div
                class="absolute -top-1 -right-1 text-white bg-blue-600 rounded-full w-4 h-4 text-xs flex justify-center items-center z-20"
                *ngIf="boards.length">{{boards.length}}</div>
            </div>
          </div>
          <div class="flex flex-col justify-center">
            <span
              [class]="boards.length ? 'text-base font-medium text-gray-900 dark:text-white' : 'text-base font-medium text-gray-500 dark:text-gray-400'">Pin
              to Existing Board</span>
            <p
              [class]="boards.length ? 'text-xs text-gray-500 dark:text-gray-400' : 'text-xs text-gray-400 dark:text-gray-500'">
              <span *ngIf="boards.length">Add to one of your existing boards</span>
              <span *ngIf="!boards.length">No boards available</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="flex-1 overflow-y-auto">
    <div class="bg-panel dark:bg-dark-panel">
      <div *ngIf="action === PinAction.ADD_NEW"
        class="p-4 border-t bg-panel dark:bg-dark-panel dark:border-t-dark-background">
        <div [@slideAnimation]="action === PinAction.ADD_NEW ? 'in' : 'out'">
          <div class="flex flex-col bg-panel dark:bg-dark-panel">
            <div
              class="flex bg-white dark:bg-dark-sidebar border border-gray-200 dark:border-none rounded-md items-end overflow-hidden">
              <textarea placeholder="Enter board headline here ..." [(ngModel)]="newBoardTitle"
                class="p-2 w-full focus:outline-none resize-none text-gray-600 dark:text-gray-50 bg-white dark:bg-dark-sidebar h-[254px]"
                rows="7"></textarea>
              <button [disabled]="onLoading" (click)="suggerestBoardTitle()"
                class="bg-button dark:bg-dark-button hover:text-gray-100 hover:bg-gray-500 bg-gray-800 p-2 h-full text-white rounded-md m-1 gap-2 border-gray-200 w-[180px] flex items-end justify-center">
                <ng-container *ngIf="!onLoading; else loading">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-6 h-6 text-yellow-400">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
                  </svg>
                  Inspire
                </ng-container>
                <ng-template #loading>
                  <img src="./../../../../assets/img/loading-gray.gif" alt="loading..." class="max-h-6 max-w-none" />
                </ng-template>
              </button>
            </div>

            <div class="flex flex-row text-xs  p-2 bg-yellow-200 rounded-md mt-4 text-yellow-600 items-center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="w-6 h-6 mr-2">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
              </svg>
              <div class="text-yellow-600">By default, all new boards are created in the <span
                  class="font-bold">DRAFT</span>
                stage</div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="action === PinAction.ADD_TO_EXISTING"
        class="p-2 w-full overflow-y-auto border-t-2 bg-panel dark:bg-dark-panel dark:border-t-dark-background">
        <div [@slideAnimation]="action === PinAction.ADD_TO_EXISTING ? 'in' : 'out'">
          <div
            class="flex items-center border border-gray-200 dark:border-none dark:bg-dark-background rounded-md w-full mb-1"
            *ngIf="boards.length">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
              class="w-5 h-5 text-gray-500 ml-2">
              <path fill-rule="evenodd"
                d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z"
                clip-rule="evenodd" />
            </svg>
            <input type="text" placeholder="Search Board" (keyup)="onSearch($event)" [(ngModel)]="searchTerm"
              class="focus:outline-none focus:ring-0 p-2 pl-1 w-full bg-transparent border-none text-gray-700" />
          </div>

          @if (filteredBoards.length) {
          @for (board of filteredBoards; track $index) {
          <div (click)="!checkIfExistInBoard(board) && pinToBoard(board.boardUUID)"
            class="p-2 bg-gray-50 border-b-1 border flex justify-between items-top text-gray-600 hover:bg-gray-100 cursor-pointer disabled:cursor-not-allowed bg-panel dark:bg-dark-panel dark:text-white dark:border-dark-background">
            <div class="flex flex-row justify-start items-top  " [class.disabled]="checkIfExistInBoard(board)">
              <div class="p-2">
                @if (!checkIfExistInBoard(board)) {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
                  <path
                    d="M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z" />
                </svg>
                } @else {
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide lucide-pin text-header dark:text-white h-5 w-5">
                  <line x1="12" x2="12" y1="17" y2="22" />
                  <path
                    d="M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z" />
                </svg>
                }
              </div>
              <div class="flex flex-col">
                <div class="text-sm mr-4">
                  {{board.title}}
                  <span class="create-date text-gray-500 dark:text-gray-300 flex">created on:
                    {{getFormattedDateTime(board.createDate)}}</span>
                </div>
                <div *ngIf="checkIfExistInBoard(board)">
                  <span class="p-1 bg-yellow-500 text-yellow-800 rounded-md text-sm mr-2">Pinned Here</span>
                </div>
              </div>
            </div>

            <div class="flex flex-col items-top gap-4 mr-3">
              <div class="flex flex-row text-[12px] gap-2 justify-right text-gray-900" *ngIf="board.articleCount">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="w-5 h-5 text-gray-400">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 0 1-2.25 2.25M16.5 7.5V18a2.25 2.25 0 0 0 2.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 0 0 2.25 2.25h13.5M6 7.5h3v3H6v-3Z" />
                </svg>
                <span class="text-gray-600 dark:text-gray-300 font-semibold">{{board.articleCount}}</span>
              </div>

              <div class="flex flex-row text-[12px] gap-2 justify-right text-gray-900"
                *ngIf="board.calendarActivitiesCount">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="w-5 h-5 text-gray-400">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z" />
                </svg>
                <span class="text-gray-600 dark:text-gray-300 font-semibold">{{board.calendarActivitiesCount}}</span>
              </div>
            </div>
          </div>
          }
          } @else {
          @if (searchTerm.length) {
          <div
            class="w-full h-full flex flex-col justify-center items-center text-gray-500 border rounded-md border-gray-200 not-found">
            <img src="./../../../../assets/img/not-found.png" class="w-24 h-24 opacity-50 dark:filter dark:invert" />
            <span class="items-center mt-2">We couldn't find what you searched for.</span>
            <span class="items-center text-sm">Try searching again</span>
          </div>
          }
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Fixed Footer -->
  <div class="bg-white dark:bg-dark-sidebar border-t border-gray-200 dark:border-dark-background p-3">
    <div class="flex flex-row justify-end gap-3">
      <button (click)="closeModal()"
        class="px-4 py-1.5 text-sm bg-red-500 text-white hover:bg-red-600 rounded-md transition-colors">
        Cancel
      </button>
      <button (click)="addNew()" *ngIf="action === PinAction.ADD_NEW"
        class="flex items-center px-4 py-1.5 text-sm bg-button dark:bg-dark-button text-white rounded-md hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
        [disabled]="!newBoardTitle || newBoardTitle.length === 0">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-4 h-4 mr-1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
        </svg>
        Create Board
      </button>
    </div>
  </div>
</div>
